import React from 'react';

import PropTypes from 'prop-types';

const ListView = ({ size = 16, color = '#848F9D', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" {...props}>
    <circle cx="1" cy="3.2" r="1" fill={color} />
    <rect x="4" y="2.5" width="11" height="1.6" rx="0.8" fill={color} />
    <circle cx="1" cy="8.2" r="1" fill={color} />
    <rect x="4" y="7.4" width="11" height="1.6" rx="0.8" fill={color} />
    <circle cx="1" cy="13" r="1" fill={color} />
    <rect x="4" y="12.2" width="11" height="1.6" rx="0.8" fill={color} />
  </svg>
);

ListView.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default ListView;
